import { FlucsSchema } from './Flucs.styles';

export const flucsStyles: FlucsSchema = {
  wrapper: {
    pos: 'relative',
    alignItems: 'center',
  },
  innerWrapper: {
    alignItems: 'center',
    bg: 'blackAlpha.300',
    width: 'fit-content',
    borderRadius: 'md',
    boxShadow: '0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset',
    p: '2',
    mt: '1',
    mr: ['1', '2'],
    color: 'white',
    fontWeight: 'bold',
    fontSize: '2xs',
    lineHeight: 'normal',
  },
  priceTitle: {
    as: 'p',
    color: 'white',
    fontWeight: 'bold',
    mr: '1',
  },
  priceNumber: {
    color: 'white',
    fontWeight: 'medium',
  },
  priceText: {
    color: 'white',
    mr: ['1', '2'],
    fontSize: '2xs',
    fontWeight: 'medium',
    display: 'flex',
    alignItems: 'center',
    _last: {
      mr: '0',
    },
  },
  priceTextIncreased: {
    color: 'white',
  },
  priceIcon: {
    color: 'red.500',
    textShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
    ml: '1',
  },
  priceIconIncreased: {
    color: 'alpha.100',
    textShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
    transform: 'rotate(180deg)',
  },
  lottieWrapper: {
    alignItems: 'center',
    boxSize: '6',
    border: 'none',
    borderRadius: 'md',
    ml: '1',
    bg: 'alpha.400',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.2) inset, 0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  },
  tooltipWrapper: {
    borderRadius: 'md',
    bg: '#ED8936',
    p: '3',
    display: 'block',
    position: 'relative',
  },
};
